import React from 'react'
import BlackButton from '../../../../../components/forms/blackfillButton'
import LightButton from '../../../../../components/forms/lightfillButton'

const PageNav = ({page,hasVarients,setPage,setHasvarients,sizes,colors,add_admin,check}) => {
  return (
    <div className='product_create_pagenav_container'>
        {page !== 0 && page !== 5 &&
            <LightButton Value={"Back"} Action={()=>{setPage(page-1);}} />
        }
        {page === 5 && hasVarients &&
          <LightButton Value={"Back"} Action={()=>{setPage(page-1);}} />
        }
        {page === 5 && !hasVarients &&
          <LightButton Value={"Back"} Action={()=>{setPage(page-2);}} />
        }
        <div></div>
        {page < 7 && page !== 3 && 
            <BlackButton Value={"Next"} Action={()=>{
              check(()=>{
                setPage(page+1);
              })
            }}/>
        }
        {page === 3 && colors.length > 0 && sizes.length > 0 &&
          <div style={{display:'flex'}}>
            <LightButton Value={"Varients"} Action={()=>{
              check(()=>{
                setHasvarients(true)
                setPage(page+1);
              })
            }}/>
            <div style={{width:'10px'}}></div>
            <BlackButton Value={"Next"} Action={()=>{
              check(()=>{
                setHasvarients(false)
                setPage(page+2);
              })
            }}/>
          </div>
        }
        {page === 3 && (colors.length === 0 || sizes.length === 0) &&
          <div style={{display:'flex'}}>
            <BlackButton Value={"Next"} Action={()=>{
              check(()=>{
                setHasvarients(false)
                setPage(page+2);
              })
            }}/>
          </div>
        }
        {page === 7 &&
          <BlackButton Value={"Finish"} Action={add_admin}/>
        }
    </div>
  )
}

export default PageNav
